import { AccountFormData } from './types';
import Theme from '../../../../theme';

export const DEFAULT_FORM_DATA: AccountFormData = {
    salesforceAccount: '',
    accountStatus: '',
    accountName: '',
    accountDomain: '',
    accountSE: '',
    accountCSM: '',
    accountAE: '',
    accountEmail: '',
    accountType: 1,
    cheqAccountStatus: 1,
    region: '',
    dataLocation: '',
    activeLicenses: [],
    defendDataType: [],
    servingDomain: '',
    deduceEnabled: 0,
    deduceSite: '',
    deduceApiKey: '',
};

export const FORM_STATE_OPTIONS = {
    create: 'create',
    edit: 'edit',
};

export const CLIENT_ACCOUNT_TYPE = 1;
export const INTERNAL_ACCOUNT_TYPE = 2;
export const DUMMY_SF_ACCOUNT_NAME = 'Dummy';
export const DUMMY_SF_ACCOUNT_CLIENT_ERROR =
    "The 'Dummy' Salesforce Account should be used only for internal use. For client setup, please select the correct SF ID or reach the Product Team/Biz Ops team if you can't find it in the list.\n" +
    'Please note, Internal Accounts that use the Dummy SF Account are being erased in an automated process, so avoid using it for client/prospect accounts.';
export const ACCOUNT_TYPE_OPTIONS = [
    { value: CLIENT_ACCOUNT_TYPE, label: 'Client' },
    { value: INTERNAL_ACCOUNT_TYPE, label: 'Internal' },
];

export const CHEQ_ACCOUNT_STATUS_OPTIONS = [
    { value: 1, label: 'Active' },
    { value: 0, label: 'InActive' },
];

export const DEDUCE_ENABLED_OPTIONS = [
    { value: 1, label: 'Yes' },
    { value: 0, label: 'No' },
];

export const DATATYPE = {
    SERVER: 'server',
    CLIENT: 'client',
};

export const DATA_TYPE_OPTIONS = [
    { value: DATATYPE.SERVER, label: DATATYPE.SERVER },
    { value: DATATYPE.CLIENT, label: DATATYPE.CLIENT },
];

export const INITIAL_SELECT_OPTION = { accountType: [], region: [], dataLocation: [], activeLicenses: [], defendDataType: DATA_TYPE_OPTIONS, salesforceAccounts: [] };

// @ts-ignore
export const MAIN_COLOR = Theme.palette.custom.text.primary;

export const SERVER_DEFAULT_VALUES = {
    // Primary defaults for new accounts
    productId: 1,
    mediaSpendTierId: 1,
    bundlePlan: 1,
    csmAuth0Id: 'N/A',
    seAuth0Id: 'N/A',

    // Fallback values for existing accounts
    bundlePlanFallback: 3,
    mediaSpendTierFallback: 3,
    isBlockingControlGroup: 0,

    // Empty string defaults
    city: '',
    zipCode: '',
    domain: '',
    logoUrl: '',
    phone: '',
    billingAddress: '',
    country: '',
    orgId: '',
} as const;

export const API_ERRORS = {
    ACCOUNT_CREATE_FAILED: 'Failed to create account',
    ACCOUNT_UPDATE_FAILED: 'Failed to update account',
    ACCOUNT_STATUS_UPDATE_FAILED: 'Failed to update account status',
    CURRENT_ACCOUNT_REQUIRED: 'Current account data is required for updates',
    INVALID_RTI_SETTINGS: 'Invalid RTI settings format',
    LICENSE_SETUP_FAILED: 'Failed to set up licenses',
    LICENSE_UPDATE_FAILED: 'Failed to update licenses',
    LICENSE_DETAILS_RETRIEVAL_FAILED: 'Failed to retrieve license details',
    INTEGRATION_LICENSE_UPDATE_FAILED: 'Failed to update integration licenses',
    RTI_SETTINGS_CREATE_FAILED: 'Failed to create RTI settings',
    RTI_SETTINGS_UPDATE_FAILED: 'Failed to update RTI settings',
    UNKNOWN_ERROR: 'Unknown error',
    UNKNOWN_ERROR_OCCURRED: 'Unknown error occurred',
    DEDUCE_CONFIGURATION_UPDATE_FAILED: 'Failed to update Deduce configuration',
} as const;
